const images = {
  doc: require("./doc.png"),
  logo: require("./logo-colored.svg").default,
  logotransparent: require("./logo-transparent.png"),
  avatar: require("./avatar.png"),
  logoicon: require("./logo-icon-colored.png"),
  filedownload: require("./import-file-icon.jpg").default,
};

export default images;
